import React, { useEffect, useState, useRef } from "react";
import profilePic from "../../images/happy-birthday-background-sign-tropical-beach-hawaii-63372910.jpg.webp";
import { ImDownload3 } from "react-icons/im";
import axios from "axios";
import TemplateAccordian from "../TemplateAccordian";
import { Upload } from 'lucide-react';
import { useContext } from "react";
import { EventDataContext } from "../EventDataContext";

import businessPhoto from "../../images/BoothBloom_Banner_Business.jpg";
import weddingPhoto from "../../images/BoothBloom_Banner_Wedding.jpg";
import birthdayPhoto from "../../images/BoothBloom_Banner_Birthday.jpg";
import otherPhoto from "../../images/BoothBloom_Banner_Other.jpg";

const TemplateTab = ({ brandingColours, eventId }) => {
  const { EventData, setEventData } = useContext(EventDataContext);


    let coverPic = otherPhoto;
    if (EventData.eventType == "corporate") {
      coverPic = businessPhoto;
    } else if (EventData.eventType == "birthday") {
      coverPic = birthdayPhoto;
    } else if (EventData.eventType == "wedding") coverPic = weddingPhoto;

  const [isOpen, setIsOpen] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [previewContent, setPreviewContent] = useState(null);
  const [realImageUrl, setRealImageUrl] = useState(null);
  const [selectedVersion, setSelectedVersion] = useState(null);
  const [uploadDone, setUploadDone] = useState(0);
  const [loading, setLoading] = useState(true);  // New state for loading
  const fileInputRef = useRef(null);

 

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        setLoading(true);  // Set loading to true before fetching templates
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/client/getTemplate/${EventData._id}`,
          { withCredentials: true }
        );
        if (res.data?.templates?.length > 0) {
          const templatesFromApi = res.data.templates;  // no sorting needed
          setTemplates(templatesFromApi);
          const latestTemplate = templatesFromApi[templatesFromApi.length - 1];
          setSelectedTemplate(latestTemplate);
          setPreviewContent(latestTemplate.thumbnailUrl);
          setRealImageUrl(latestTemplate.originalImageUrl);
          setSelectedVersion(templatesFromApi.length); // Latest version has highest number
        } else {
          setTemplates([]);  // In case no templates are available
        }
      } catch (error) {
        console.error("Error fetching templates:", error);
      } finally {
        setLoading(false);  // Set loading to false once data is fetched
      }
    };

    fetchTemplates();
  }, []);

  const handleVersionClick = (index) => {
    const template = templates[index];
    setSelectedTemplate(template);
    setIsOpen(false);
    setPreviewContent(template.thumbnailUrl);
    setRealImageUrl(template.originalImageUrl);
    setSelectedVersion(index + 1);  // index + 1 to display version number
  };

  return (
    <div style={{ width: "98%", display: "flex", gap: "20px",  }}>
      <div style={{ flex: 1 }}>
      <div style={{ position: 'relative', width: '100%', height: '224px', overflow: 'hidden', backgroundColor: '#000', borderRadius: "8px" }}>
          {/* 1. The Base Image */}
          <img
            src={coverPic}
            alt="cover"
            style={{ 
              width: "100%", 
              height: "100%", 
              objectFit: "cover",
              objectPosition: "top" 
            }}
          />

          {/* 2. The Blur Overlay */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            maskImage: 'radial-gradient(circle, transparent 30%, black 80%)',
            WebkitMaskImage: 'radial-gradient(circle, transparent 30%, black 80%)',
          }} />
          
          {/* 3. The Bottom Gradient & Text Overlay */}
          <div style={{
            position: 'absolute',
            bottom: '0',
            left: '0',
            width: '100%',
            background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
            color: 'white',
            padding: '20px',
            boxSizing: 'border-box'
          }}>
            <h1 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold' }}>
              Photostrip Template
            </h1>
            <p style={{ margin: '5px 0 0 0', fontSize: '14px', opacity: 0.9 }}>
              Last Updated: {selectedTemplate && selectedTemplate.timestamp ? new Date(selectedTemplate.timestamp).toLocaleDateString() : ""}
            </p>
          </div>
          </div>

        {/* <div style={{
          border: "1px solid #D9D9D9",
          borderTop: "none",
          marginTop: "-5px",

        }}></div> */}

        <div style={{ border : '1px solid #d4d4d4', borderTop: 'none', borderBottom: 'none', borderLeft: 'none', padding: "15px"   }} ><TemplateAccordian sender="client" brandingColours={brandingColours} /> </div>
      </div>

      <div style={{ width: "300px" }}>
        {/* Dropdown Selector */}
        {loading && (
          <div
            style={{
              padding: "10px 15px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              backgroundColor: "#fff",
              fontSize: "14px",
              marginBottom: "10px",
            }}
          >
            Loading versions...
          </div>
        )}

        {!loading && templates.length === 0 && (
          <div
            style={{
              padding: "10px 15px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              backgroundColor: "#fff",
              fontSize: "14px",
              marginBottom: "10px",
            }}
          >
            No versions available
          </div>
        )}

        {selectedTemplate && (
          <div style={{ position: "relative" }}>
            <div
              style={{
                padding: "10px 15px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                backgroundColor: "#fff",
                fontSize: "14px",
                cursor: "pointer",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              onClick={toggleDropdown}
            >
              {selectedVersion ? `Version ${selectedVersion}` : "Select Version"}
              <span style={{ marginLeft: "10px", fontSize: "12px" }}>
                &#9660;
              </span>
            </div>

            {isOpen && (
              <div
                style={{
                  position: "absolute",
                  top: "42px",
                  left: 0,
                  width: "100%",
                  backgroundColor: "#ffffff",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  zIndex: 10,
                  overflowY: "auto",
                  maxHeight: "200px",
                }}
              >
                {templates.map((template, index) => (
                  <div
                    key={template.timestamp}
                    onClick={() => handleVersionClick(index)}
                    style={{
                      padding: "10px 15px",
                      borderBottom: "1px solid #eee",
                      cursor: "pointer",
                      fontSize: "14px",
                      backgroundColor: selectedTemplate === template ? "#F0F0FF" : "transparent",
                      color: "#1C1154",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F5F5FF")}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = selectedTemplate === template ? "#F0F0FF" : "transparent")}
                  >
                    Version {index + 1}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Preview Box */}
        {selectedTemplate && (
          <div
            style={{
              marginTop: "15px",
              width: "100%",
              height: "180px",
              border: "1px solid #ccc",
              borderRadius: "5px",
              padding: "10px",
              fontSize: "13px",
              lineHeight: "1.4",
              color: "#333",
              backgroundColor: "#FAFAFA",
              overflowY: "auto",
              whiteSpace: "pre-wrap",
              fontFamily: "monospace",
            }}
          >
            {previewContent ? (
              <img src={previewContent} alt="Preview" style={{ width: "100%", height: "auto" }} />
            ) : (
              "Loading..."
            )}
          </div>
        )}

        {/* Download Button */}
        {selectedTemplate && (
          <div style={{ marginTop: "15px", marginBottom: "30px" }}>
            <a
              href={realImageUrl}
              target="_blank"
              rel="noopener noreferrer"
              download
              style={{ textDecoration: "none", color: "white" }}
            >
              <button
                style={{
                  marginTop: "10px",
                  width: "100%",
                  height: "35px",
                  background: brandingColours?.primaryColor || "#1C1154",
                  color: brandingColours?.secondaryColor || "#ffffff",
                  fontSize: "15px",
                  border: "none",
                  cursor: "pointer",
                  borderRadius: "5px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <ImDownload3 />
                Download
              </button>
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default TemplateTab;
